import React from "react";

const WorshipSong = ({ title, youtubeUrl }) => {
  return (
    <section className="p-6 md:p-8 text-center bg-gray-900">
      <h2 className="text-2xl md:text-3xl font-bold mb-6">{title}</h2>

      <div className="flex justify-center">
        <div className="w-full max-w-4xl aspect-video rounded-xl overflow-hidden shadow-lg">
          <iframe
            className="w-full h-full"
            src={youtubeUrl}
            title={title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </div>
    </section>
  );
};

export default WorshipSong;